<form (ngSubmit)="submit()" novalidate [formGroup]="form">
  <ion-list>
    <ion-item>
      <ion-label floating>
        @if (formErrors.has('email')) {
          <span color="danger"><br />{{formErrors.get('email')}}</span>
        }
      </ion-label>
      <ion-input formControlName="email" type="email" [placeholder]="emailPlaceHolder"></ion-input>
    </ion-item>
  </ion-list>

  <div padding>
    <ion-button type="submit" [disabled]="!form.valid" ion-button color="primary" expand="block">
      {{ 'Auth.SendVerificationCode' | translate }}
    </ion-button>
  </div>
</form>